export enum LeaveType {
    CustomerRequest = 1,
    AcceptedAnotherProposal = 2,
    ConsultantRequestedDismissal = 3,
    Internalization = 4,
    ProjectClosure = 5,
    EndOfContract = 6,
    Others = 7,
    IncompatibleProfile = 8,
    Ethics = 9,
    Restructuring = 10,
    UnsatisfiedWithClientOrProject = 11,
    InternationalOpportunity = 12,
    NationalPropositionChallenge = 13,
    PoorPerformance = 14
}



// WEBPACK FOOTER //
// ./src/app/shared/enums/LeaveType.ts